module.exports = __webpack_public_path__ + "static/img/clause_letter104.a01544c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter104.png
// module id = zVjK
// module chunks = 1